import { Trans, useT } from '@eturi/react-i18next'
import { memo } from 'react'
import { Link } from 'react-router-dom'
import { HybridModal } from '../../widgets'
import PairingComparisonTable from './PairingComparisonTable'

type FullPairModalProps = {
	readonly onClose: () => void
}

const FullPairModal = ({ onClose }: FullPairModalProps) => {
	const [t] = useT('')

	return (
		<HybridModal header={t('actions.full_pair')} onClose={onClose}>
			<div className="flex flex-col gap-4 items-center max-w-[500px]">
				<p>
					<Trans i18nKey="connect.pair_modals.full_pair_modal_instruction" t={t} />
				</p>
				<PairingComparisonTable />
				<div className="max-w-96 w-full flex flex-col my-3 mx-auto">
					<Link
						className="btn btn-teal mt-3.5 min-w-32"
						to={{ pathname: '/connect', search: 'hideSkip=true' }}
						onClick={onClose}
					>
						{t('actions.full_pair')}
					</Link>
				</div>
			</div>
		</HybridModal>
	)
}

export default /*@__PURE__*/ memo(FullPairModal)
